import { render, staticRenderFns } from "./Indexer.vue?vue&type=template&id=64ce43d6&"
import script from "./Indexer.vue?vue&type=script&lang=js&"
export * from "./Indexer.vue?vue&type=script&lang=js&"
import style0 from "./Indexer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports